export const LAUNCH_CRITICAL_EVENT_STEP_UUID =
  '31f6d479-d189-54d8-8a64-711424c81e52';

export const LAUNCH_CRITICAL_EVENT_TYPE_UUID =
  '0cbd0aaf-07a2-5d8b-8bec-1d8f2966b541';

export const isLaunchCriticalEventStep = scriptStep =>
  scriptStep.uuid === LAUNCH_CRITICAL_EVENT_STEP_UUID;

export const templateIdInputField = 'Template ID';
export const templateNameInputField = 'Template Name';
export const templateTitleInputField = 'Title';
export const templateDescriptionInputField = 'Description';
export const templateEventTypeField = 'Event Type';
